package com.zaurh.portfolio.di

import org.koin.core.context.startKoin

fun initKoin() {
    startKoin {
        modules(repositoryModule, networkModule)
    }
}